import {typeExport} from "../../../../redux/store/type";

const reducerLoginScreen = (state = { NoInternetDialog: false, results: null ,  isLoading:false, }, action) => {
    switch (action.type) {
        case typeExport.LoginScreen_SERVICE_PENDING:
            return Object.assign({}, state, {
                NoInternetDialog: false,
                isLoading:true ,
                results:null
            });
        case typeExport.LoginScreen_SERVICE_ERROR:
            return Object.assign({}, state, {
                NoInternetDialog: true,
                isLoading:false ,
                error: action.error
            });
        case typeExport.LoginScreen_SERVICE_SUCCESS:
            return Object.assign({}, state, {
                results: action.results,
                NoInternetDialog: false ,
                isLoading:false ,

            });

            case typeExport.LoginScreen_SERVICE_REFRESH:
            return Object.assign({}, state, {
                results: action.results,
                NoInternetDialog: false ,
                isLoading:false ,
            });

        default:
            return state;
    }
}

export default reducerLoginScreen;
